module.exports = __webpack_public_path__ + "media/raise_capital/hero-f0023b53.jpg";